import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AnalysisOfCorrelatedPositionsComponent from '../components/analysisOfCorrelatedPositionsComponent';
import IAppState from '../../../IAppState';
import ActMain from '../../../act-main';
import ActSummary from '../../SummaryPage/state/act-summary';
import { clientUrlPrefix } from '../../../settings';
import {IAnalysisOfCorrelatedPositionsData, IAnalysisOfCorrelatedPositionsFunctions} from '../props/IAnalysisOfCorrelatedPositionsComponentProps';



interface IOwnProps {
    ecNumber?: string;
    choice;
    customQuery?: boolean;
    history: any;
}

const mapStateToProps = (
    { mainState }: IAppState,
    ownProps: IOwnProps
): IAnalysisOfCorrelatedPositionsData => {
    return {

        ...mainState,
        zScoreThreshold: mainState.advancedOptions.zScoreThreshold,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IOwnProps
): IAnalysisOfCorrelatedPositionsFunctions => ({
    changeZScoreThreshold : (zScoreThreshold: number ) => dispatch(ActMain.changeZScoreThreshold(zScoreThreshold)),
});

const AnalysisOfCorrelatedPositionsContainer = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AnalysisOfCorrelatedPositionsComponent)
);
export default AnalysisOfCorrelatedPositionsContainer;
